app.service("ProductWrapService", ['$rootScope', 'ProductService', function ($rootScope, ProductService) {

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const ProductWrapModel = modelConstructor.extend(ProductService.BasicProductModel, {
        id: "product_wrap",
        base_component_id: "wrap",
        applyItemHandler: applyItemHandler,
        is_single_item_model: true,
        is_g: false
    });

    this.factory = new ProductService.BasicProductModelFactory({
        birth: function (values) {
            return new ProductWrapModel(values);
        },

        validVariationPointers: function (variationIDs) {
            return ['browse_id', 'request_range_id', 'site_range_id', 'style_id', 'parent_category_id'];
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const siteRangeID = variationIDs.site_range_id;
        const parentCategoryID = variationIDs.parent_category_id;

        const notes = siteRangeID === "zurfiz" ? ['matching_edge'] : null;
        const isG = parentCategoryID === "wrap_panel_g"

        siteHelper.applyValues(model, {
            notes: notes,
            is_g: isG
        });
    }


    function applyItemHandler(product) {
        this.super(product);

        const model = this.root;

        const imgSrc = !model.is_g ?
            "/img/browse/product/wrap/wrap-c.jpg" :
            "/img/browse/product/wrap/wrap-g.jpg"


        product.group_name = getGroupName(product, model);

        siteHelper.applyValues(product, {
            option_layout: "list",
            quantity: 1,
            height: '',
            width: '',
            depth: '',
            applynonstdsurcharge: false,
            rotate_grain: false,
            is_g: model.is_g,
            img_src: imgSrc,

            limits: function () {
                if (!product.rotate_grain) {
                    return product.normal_limits;
                }
                return product.rotated_limits
            },
            finalPrice: function () {
                return finalPrice(product);
            }
        });
    }

    function getGroupName(product, model) {
        if (product.name) {
            return product.name;
        }
        if (model.parent_category_cache && model.parent_category_cache.name) {
            return model.parent_category_cache.name;
        }
        return product.api_code;
    }

    function finalPrice(product) {
        if (!product.width || !product.height || !product.depth || (product.is_g && !product.return)) {
            return 0;
        }

        return $rootScope.service.product.finalPrice(product);
    }

}]);